export default __webpack_public_path__ + "static/ESITCMetz-9ea4fd8a997f76dfdf35c2ea70254939.png";